import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FormGroup } from 'reactstrap';

import { messages } from '../../../_shared/i18n/messages';

import './FormSection.scss';

const propTypes = {

	/**
	 * The form section.
	 */
	section: PropTypes.shape({

		/**
		 * The unique ID of the section.
		 */
		id: PropTypes.string.isRequired,

		/**
		 * The title text for the section.
		 */
		title: PropTypes.string,

		/**
		 * The description text for the section.
		 */
		description: PropTypes.string,

	}).isRequired,

	/**
	 * The position of the section within the sections list. Optional: a
	 * standalone section (not part of a list) simply renders with its header.
	 */
	index: PropTypes.number,

	/**
	 * The component children.
	 */
	children: PropTypes.node,

};

/**
 * Shared component to render a form section.
 *
 * @param {Object} props The props.
 * @returns {Object} The rendered component.
 */
const FormSection = (props) => {

	const { section, index = 1, children } = props;

	if (index === 0) {
		return children;
	}

	return (
		<Fragment>
			<FormGroup className="tc-form-section">
				{section.title && section.title.length > 0 &&
					<span className="tc-form-section-title">
						{section.title}
					</span>
				}
				{(!section.title || section.title.length === 0) &&
					<span className="tc-form-section-title">
						<FormattedMessage
							{...messages.TC_COMPONENTS_FORM_SECTION_TITLE_DEFAULT} />
					</span>
				}
				{section.description &&
					<span>
						{section.description}
					</span>
				}
			</FormGroup>
			{children}
		</Fragment>
	);

};

FormSection.propTypes = propTypes;

export default FormSection;
